<template>
    <Head title="Applicant Management"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <Button
                            label="Input Test Selection"
                            icon="pi pi-envelope"
                            class="p-button-primary mr-2"
                            @click="loadAssessementDialog"
                            :disabled="
                                !selectedModels || !selectedModels.length || selectedModels.length > 1
                            "
                        />
                        <SplitButton label="Process Candidate" icon="pi pi-check" :model="splitButtonMenus" class="p-button-secondary mr-2"
                        :disabled="
                                !selectedModels || !selectedModels.length || selectedModels.length > 1
                        "></SplitButton>
                    </template>
                    <template v-slot:end>
                        <FileUpload class="mr-2" mode="basic" name="file[]" accept=".xls, .xlsx" :maxFileSize="1000000" customUpload @uploader="customUploader" :auto="true" choose-label="Import Applicant" />
                        <Button
                                label="Print Selected Candidate"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                @click="exportCandidateReport"
                                :loading="isExporting"
                                :disabled="
                                    !selectedModels || !selectedModels.length || selectedModels.length > 1
                                "
                            />
                        <Button
                                label="Print Summary"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                @click="exportSummaryReport"
                                :loading="isExporting"
                            />
                    </template>
                </Toolbar>

                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    :selectAll="selectAll"
                    @select-all-change="onSelectAllChange"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage Applicant</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="searchFilter"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                    ></Column>
                    <Column
                        field="ID"
                        header="ID"
                        :sortable="true"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Id</span>
                            {{ slotProps.data.id }}
                        </template>
                    </Column>
                    <Column
                        field="name"
                        header="Name"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            <Link :href="`${this.$page.props.appUrl}candidates/${slotProps.data.id}/edit`">
                                {{ slotProps.data.name }}
                            </Link>
                        </template>
                    </Column>
                    <Column
                        field="gender"
                        header="Gender"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Gender</span>
                            {{ slotProps.data.gender }}
                        </template>
                    </Column>
                    <Column
                        field="last_education_level"
                        header="Last Education"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Last Education</span>
                            {{ slotProps.data.last_education_level }}
                        </template>
                    </Column>
                    <Column
                        field="age"
                        header="Age"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Age</span>
                            {{ slotProps.data.age }}
                        </template>
                    </Column>
                    <Column
                        field="test_result"
                        header="Test Result"
                        :sortable="true"
                    >
                        <template #body="slotProps">
                            <span :class="'applicant-badge status-' + slotProps.data.test_result" >{{ slotProps.data.test_result }}</span>
                        </template>
                    </Column>
                    <Column>
                        <template #body="slotProps">
                            <Button
                                label="Detail"
                                icon="pi pi-eye"
                                class="mr-2"
                                @click="editModel(slotProps.data.id)"
                            />
                        </template>
                    </Column>
                </DataTable>

                <Dialog
                    v-model:visible="selectionTestDialog"
                    :style="{ width: '900px' }"
                    header="Selection Test Detail"
                    :modal="true"
                    class="p-fluid"
                >
                    <SelectionTestDialog :models="selectedModels" ref="selectionTest"></SelectionTestDialog>
                    <template #footer>
                        <Button
                            label="Print Test Result"
                            icon="pi pi-print"
                            class="p-button-text"
                            @click="exportManualAssessementResult"
                        />
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                        <Button
                            label="Save"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="saveAssessement"
                        />
                    </template>
                </Dialog>
                <Dialog
                    v-model:visible="acceptApplicantDialog"
                    :style="{ width: '450px' }"
                    header="Accept Candidate"
                    :modal="true"
                    :closeable="true"
                >
                    <AcceptApplicantDialog :models="selectedModels" ref="acceptApplicant"></AcceptApplicantDialog>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="closeDialog"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="acceptModel"
                        />
                    </template>
                </Dialog>
                <Dialog
                    v-model:visible="rejectApplicantDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <RejectApplicantDialog></RejectApplicantDialog>
                            <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="rejectModel"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head, Link } from "@inertiajs/inertia-vue3";
import Badge from 'primevue/badge';
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Message from "primevue/message";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import DatatableService from "../../Services/DatatableService";
import SplitButton from "primevue/splitbutton";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";
import SelectionTestDialog from './Components/SelectionTestDialog.vue';
import AcceptApplicantDialog from "./Components/AcceptApplicantDialog.vue";
import RejectApplicantDialog from "./Components/RejectApplicantDialog.vue";
import FileUpload from "primevue/fileupload";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Link,
        Badge,
        Button,
        InputText,
        Message,
        Toolbar,
        Toast,
        DataTable,
        Column,
        Dropdown,
        Dialog,
        SplitButton,
        SelectionTestDialog,
        AcceptApplicantDialog,
        RejectApplicantDialog,
        FileUpload,
    },
    data() {
        return {
            searchFilter: "",
            filters: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            lazyParams: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            splitButtonMenus:[
				{
					label: 'Accept',
					icon: 'pi pi-checklist',
					command: () => {
                        // this.acceptApplicantDialog = true;
                        const rawObject = {...this.selectedModels[0]};
                        this.$inertia.get(`${this.$page.props.appUrl}candidate-accept/${rawObject.id}`)
					},
                },
                {
                    label: 'Reject',
					icon: 'pi pi-cancel',
					command: () => {
						this.rejectApplicantDialog = true;
                    },
                },
            ],
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            model: {},
            models: null,
            selectionTestDialog: false,
            deleteModelDialog: false,
            acceptApplicantDialog: false,
            rejectApplicantDialog: false,
            selectedModels: null,
            submitted: false,
            selectAll: false,
            isExporting: false,
            uploadedFile: [],
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };

        if(localStorage.getItem('lazyParams')){
            this.lazyParams = JSON.parse(localStorage.getItem('lazyParams'));
            this.searchFilter = this.lazyParams.filters.global.value;
        }

        this.loadLazyData();
    },
    methods: {
        loadLazyData() {
            this.loading = true;
            this.datatableService
                .getData(`${this.$page.props.appUrl}api/applicants/datatable`, this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        loadAssessementDialog(){
            this.selectionTestDialog = true;
        },
        convertDate(str) {
            /** Script From https://stackoverflow.com/a/6292335 */
            var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [date.getFullYear(), mnth, day].join("-");
        },
        saveAssessement(){
            const rawObject = {...this.selectedModels[0]};
            let data = this.$refs.selectionTest.assessmentResults;

            data.forEach(element => {
                let selection_date = this.convertDate(element.selection_date);
                element.selection_date = selection_date;
            });

            axios.put(`${this.$page.props.appUrl}api/applicant-assessements/${rawObject.id}`, data)
            .then((response) => {
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Applicant Assessed",
                    life: 3000,
                });
            }).
            catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Applicant Not Assessed " + error,
                    life: 3000,
                });
            });
        },
        exportCandidateReport(){
            this.isExporting = true;
            const rawObject = {...this.selectedModels[0]};
            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/applicants/${rawObject.id}/exports`,
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Candidate.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportSummaryReport(){
            this.isExporting = true;
            axios({
                method: 'get',
                url: this.$page.props.appUrl + 'api/applicant-summary-export',
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','summary-candidate.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        exportManualAssessementResult(){
            this.isExporting = true;
            const rawObject = {...this.selectedModels[0]};
            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/applicants/${rawObject.id}/assessements/exports`,
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Candidate Assessement.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        onSelectAllChange(event) {
            const selectAll = event.checked;
            if (selectAll) {
                this.datatableService.getData(this.route("applicants.index"),this.lazyParams).then((data) => {
                    this.selectAll = true;
                    this.selectedModels = data.data;
                });
            } else {
                this.selectAll = false;
                this.selectedModels = null;
            }
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams.first = event.first;
            this.lazyParams.page = event.page;
            this.lazyParams.pageCount = event.pageCount;
            this.lazyParams.rows = event.rows;
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams.sortField = event.sortField;
            this.lazyParams.sortOrder = event.sortOrder;
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        onFilter(event) {
            this.lazyParams.filters['global'] = {  value: this.searchFilter };
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        hideDialog() {
            this.selectionTestDialog = false;
        },
        editModel(id){
            this.$inertia.get(this.route('candidates.edit', [id]));
        },
        acceptModel(){
            const rawObject = {...this.selectedModels[0]};
            let data = this.$refs.acceptApplicant.form;
            data.applicant_id = rawObject.id;

            this.$refs.acceptApplicant.submitted = true;

            axios.post(`${this.$page.props.appUrl}api/applicants/${rawObject.id}/accept`, data)
                 .then((response) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Applicant Accepted",
                        life: 3000,
                    });
                    this.acceptApplicantDialog = false;
                    this.selectedModels = null;
                    this.loadLazyData();
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Applicant not accepted " + error,
                        life: 3000,
                    });
                });

            this.$refs.acceptApplicant.submitted = false;
        },
        rejectModel() {
            const rawObject = {...this.selectedModels[0]};
            axios
                .delete("api/applicants/" + rawObject.id + "/reject")
                .then((response) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Applicant Deleted",
                        life: 3000,
                    });
                    this.rejectApplicantDialog = false;
                    this.selectedModels = null;
                    this.loadLazyData();
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Applicant not deleted",
                        life: 3000,
                    });
                });
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
        customUploader(event){
            this.uploadedFile = event.files[0];
            let formData = new FormData();
            formData.append('file', this.uploadedFile);

            axios.post(`${this.$page.props.appUrl}api/applicants/imports`, formData)
                .then((data) =>
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Import Candidate Completed",
                        life: 3000,
                    })
                )
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Import Candidate",
                        detail: error,
                        life: 3000,
                    });
                })
        }
    },
};
</script>

<style scoped lang="scss">
@import "../../../assets/demo/badges.scss";
</style>
